import './aggregationComponent.scss';
import {DeepReadonly} from 'utility-types';
import {Aggregation} from '../search/search-types';
import classNames from 'clsx';
import React, {useEffect, useState} from 'react';
import {HibuTooltip} from '../common/hibuTooltip/hibuTooltip';

type AggregationComponentProps = {
    aggregation: DeepReadonly<Aggregation>;
};

export const AggregationComponent = React.memo((props: AggregationComponentProps) => {
    const refTag = React.createRef<HTMLSpanElement>();
    const [ellipsisActive, setEllipsisActive] = useState<boolean>(false);

    useEffect(() => {
        if (refTag.current) {
            setEllipsisActive(refTag.current.offsetWidth < refTag.current.scrollWidth);
        }
    }, [refTag]);

    const showAggregation = (value: string) => {
        if (ellipsisActive) {
            return (
                <HibuTooltip tooltipKey={value} placement={'top'} key={value}>
                    <span ref={refTag} className={classNames('tag-value')}>
                        {value + ' '}
                    </span>
                </HibuTooltip>
            );
        } else {
            return (
                <span ref={refTag} className={classNames('tag-value')}>
                    {value + ' '}
                </span>
            );
        }
    };

    return (
        <div>
            {Object.entries(props.aggregation.values).map((aggregationItem) => {
                return (
                    <div id="aggregation-component" key={aggregationItem[0]}>
                        <div className="list-group-item-title">{aggregationItem[0]}</div>
                        <div className="tag-component">{aggregationItem[1].map((value) => showAggregation(value))}</div>
                    </div>
                );
            })}
        </div>
    );
});
